import { render, staticRenderFns } from "./ServiceTypeServicesSelect.vue?vue&type=template&id=b3b22146"
import script from "./ServiceTypeServicesSelect.vue?vue&type=script&lang=js"
export * from "./ServiceTypeServicesSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports